import request from '@/utils/request'

/**
 * 基础个性化
 * https://www.showdoc.com.cn/1003739271891029/10377102407998189
 */
export function fetchBaseStyle(params) {
    return request({
        url: '/api/selection_library/mod/pub.flutter.selection_library_base',
        params: params,
        method: 'get'
    })
}
